// Generated from merged schedule PDFs in Downloads.
// Last partial update: files 6-10 parsed into tmp/parsed-schedules-update6to10.json
// Updated scopes: Jeli|Terminal 1, Gua Musang|Terminal 1, Gua Musang|Terminal 2, Bachok|Terminal 2, Bachok|Terminal 1
// Generated schedule days: 690
// Generated schedule sessions: 1097
// Base PDF sessions in latest partial update: 270

const schedules = [
  {
    "date": "2026-02-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-22",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-22",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-22",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-22",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 1",
        "teacher": "MA’AROF BIN AB RAHMAN",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-22",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 1",
        "teacher": "MA’AROF BIN AB RAHMAN",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 1",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 1",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-23",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 1",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN WAN HASLINA BINTI WAN HASAN 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 1",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN WAN HASLINA BINTI WAN HASAN 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 1",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 1",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-24",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK 1",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK 1",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK 1",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 1",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 1",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 1",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 1",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-25",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 1",
        "teacher": "PN. NORIZAN BINTI MAMAT PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 1",
        "teacher": "PN. NORIZAN BINTI MAMAT PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 1",
        "teacher": "HASNAH BT MAT DAUD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-26",
    "dayOfWeek": "thursday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 1",
        "teacher": "HASNAH BT MAT DAUD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-27",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 7 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-27",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 7 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-27",
    "dayOfWeek": "friday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 2",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-27",
    "dayOfWeek": "friday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 2",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-27",
    "dayOfWeek": "friday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK MOHD ZAKI BIN HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 8",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-27",
    "dayOfWeek": "friday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK MOHD ZAKI BIN HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 8",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 9 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 9 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 1",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 1",
        "teacher": "PN NORASIAH MAC 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 1",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 1",
        "teacher": "PN NORASIAH MAC 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah 2",
        "teacher": "HASNAH BT MAT DAUD 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 2",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI MAC 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah 2",
        "teacher": "HASNAH BT MAT DAUD 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 2",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI MAC 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER --- PAGE 2 ---",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER --- PAGE 2 ---",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH AZIZAN BINTI ABDULLAH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 10 11.30 - 1.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD INTAN SAFINAZ BT ABD.HAYE-KHAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-02-28",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH AZIZAN BINTI ABDULLAH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 10 11.30 - 1.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD INTAN SAFINAZ BT ABD.HAYE-KHAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 1",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN AINON BINTI LATIFF 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 1",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN AINON BINTI LATIFF 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 2",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-01",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 2",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik 1",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN ROHAYATI BINTI MUHAMMAD ZIN 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik 1",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN ROHAYATI BINTI MUHAMMAD ZIN 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 3",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 3",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-02",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI --- PAGE 2 --- 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI --- PAGE 2 --- 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI --- PAGE 2 --- 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 2",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN --- PAGE 2 --- 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 2",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN --- PAGE 2 --- 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 2",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 2",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-03",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 2",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 2",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 3",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 3",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-04",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 2",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 2",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 3",
        "teacher": "HASNAH BT MAT DAUD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-05",
    "dayOfWeek": "thursday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 3",
        "teacher": "HASNAH BT MAT DAUD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH --- PAGE 2 --- 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH --- PAGE 2 --- 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 1",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 1",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 1",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 1",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 1",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 1",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI LAU SAO LEE",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-06",
    "dayOfWeek": "friday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI LAU SAO LEE",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      },
      {
        "startTime": "20:30",
        "endTime": "22:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "22:30",
        "endTime": "23:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      },
      {
        "startTime": "20:30",
        "endTime": "22:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "22:30",
        "endTime": "23:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 1",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 1",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 1",
        "teacher": "3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 1",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 1",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 1",
        "teacher": "3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 1",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 1",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 1",
        "teacher": "3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 1",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 1",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 1",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 1",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD SITI KHAIRIAH BINTI MUA’AINUE-DEEN",
        "type": "IVC"
      },
      {
        "startTime": "20:30",
        "endTime": "22:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NAZUMI BINTI NAWAWI",
        "type": "IVC"
      },
      {
        "startTime": "22:30",
        "endTime": "23:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-07",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD SITI KHAIRIAH BINTI MUA’AINUE-DEEN",
        "type": "IVC"
      },
      {
        "startTime": "20:30",
        "endTime": "22:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NAZUMI BINTI NAWAWI",
        "type": "IVC"
      },
      {
        "startTime": "22:30",
        "endTime": "23:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 2",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 2",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 3",
        "teacher": "MA’AROF BIN AB RAHMAN --- PAGE 2 ---",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-08",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 3",
        "teacher": "MA’AROF BIN AB RAHMAN --- PAGE 2 ---",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik 2",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN MAC 2026 11",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik 2",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN MAC 2026 11",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-09",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 3",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 12",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 3",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 12",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 3",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 3",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-10",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 3",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 13",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 3",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 13",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 4",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 4",
        "teacher": "MOHAIZAAZIRA BT MAT ZAKI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-11",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 3",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 14",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 3",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 14",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 4",
        "teacher": "HASNAH BT MAT DAUD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-12",
    "dayOfWeek": "thursday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 4",
        "teacher": "HASNAH BT MAT DAUD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 7 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 7 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 2",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 2",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 2",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 2",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 2",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 2",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI HASLIZA BINTI JAAFAR",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-13",
    "dayOfWeek": "friday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI HASLIZA BINTI JAAFAR",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 9 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 9 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 2",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 2",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 2",
        "teacher": "5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 2",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 2",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 2",
        "teacher": "5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 2",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 2",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 2",
        "teacher": "5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 2",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 2",
        "teacher": "PN NORASIAH APRIL 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 2",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 2",
        "teacher": "PN NORASIAH APRIL 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK SITI NUR ADILAH BINTI ABDUL HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD HALIZA BINTI MUSTAPHA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-14",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK SITI NUR ADILAH BINTI ABDUL HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD HALIZA BINTI MUSTAPHA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN.NURSYADIAH BINTI MOHD HADI 2",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 3",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 15",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 3",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 15",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 4",
        "teacher": "MA’AROF BIN AB RAHMAN",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-15",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "15:40",
        "subject": "PLAY & TALK 4",
        "teacher": "MA’AROF BIN AB RAHMAN",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-16",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-16",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-16",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Sejarah",
        "teacher": "EN. MOHAMMAD ZAKY BIN SAFIAN SURI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-16",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik 3",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN 16",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-16",
    "dayOfWeek": "monday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik 3",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN 16",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI --- PAGE 3 --- 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI --- PAGE 3 --- 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NUR FATIHAH BINTI MOHD PAUZI --- PAGE 3 --- 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 4",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN --- PAGE 3 --- 17",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 4",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN --- PAGE 3 --- 17",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 4",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-17",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 4",
        "teacher": "NORSAZWANA BINTI QASHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "PN. NORMALIZAWATI BINTI JUSOH PN. MAZELIYANI BINTI YASA 5",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 4",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 18",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu 4",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 18",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Keroh",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 4",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-18",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 1",
    "schoolName": "SMK Kuala Krai",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 4",
        "teacher": "W. HASLIDA BT W. AZMI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-19",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Bandar Chiku",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-19",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Chiku 2",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-19",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 1",
    "schoolName": "SMK Paloh",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "Matematik",
        "teacher": "PN. NOR LAILI BINTI MOHAMAD",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-28",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-28",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-30",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-30",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-31",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-03-31",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-01",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 4",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 19",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-01",
    "dayOfWeek": "wednesday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Sejarah 4",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 19",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-01",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-01",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-02",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 4",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 20",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-02",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris 4",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 20",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-02",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-02",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-02",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 3",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 3",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 3",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 3",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 3",
        "teacher": "HAMIDAH BINTI SHAFEI 10.30 - 12.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 3",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik 4",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN APRIL 2026 21",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Kuiz Bahasa Melayu 1",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 22",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik 4",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN APRIL 2026 21",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Kuiz Bahasa Melayu 1",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 22",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-03",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 3",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 3",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 3",
        "teacher": "--- PAGE 2 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 3",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 3",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 3",
        "teacher": "--- PAGE 2 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 3",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 10.30 - 11.30 TGH",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK 3",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 11.30 - 1.30 TGH",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 3",
        "teacher": "--- PAGE 2 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Kuiz Bahasa Inggeris 1",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 23",
        "type": "Quiz"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Kuiz Matematik 1",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN AINON BINTI LATIFF 24",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Kuiz Bahasa Inggeris 1",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 23",
        "type": "Quiz"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Kuiz Matematik 1",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN AINON BINTI LATIFF 24",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 2",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 2",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 2",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 2",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH ZULIANA BINTI AB HALIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH ZULIANA BINTI AB HALIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-05",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Kuiz Sejarah 1",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN ROHAYATI BINTI MUHAMAD ZIN 25",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-04-05",
    "dayOfWeek": "sunday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Kuiz Sejarah 1",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN ROHAYATI BINTI MUHAMAD ZIN 25",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-04-06",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-06",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-07",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-07",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-09",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "18:00",
        "subject": "Bengkel Teknik Menjawab Matematik",
        "teacher": "- CIKGU QUNA 8",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-09",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "18:00",
        "subject": "Bengkel Teknik Menjawab Matematik",
        "teacher": "- CIKGU QUNA 8",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-09",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "18:00",
        "subject": "Bengkel Teknik Menjawab Matematik",
        "teacher": "- CIKGU QUNA 8",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-09",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-09",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-09",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-10",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-10",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-10",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik",
        "teacher": "-",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 5 11.30 - 1.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 5 11.30 - 1.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Melayu",
        "teacher": "TETAMU JEMPUTAN PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN PN 26 SABTU (",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Melayu",
        "teacher": "TETAMU JEMPUTAN PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN PN 26 SABTU (",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "12:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Melayu",
        "teacher": "-",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "12:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Melayu",
        "teacher": "-",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00-1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00-1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NOR ATIKAH BINTI AMARAN",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD --- PAGE 3 --- 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-11",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NOR ATIKAH BINTI AMARAN",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD --- PAGE 3 --- 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-14",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "15:30",
        "endTime": "17:30",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "TEMPAT : DEWAN ASRAMA",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-14",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "15:30",
        "endTime": "17:30",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "TEMPAT : DEWAN ASRAMA",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-14",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "15:30",
        "endTime": "17:30",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "TEMPAT : DEWAN ASRAMA",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-17",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bahasa Melayu",
        "teacher": "- CIKGU MARZUKI 2",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-17",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bahasa Melayu",
        "teacher": "- CIKGU MARZUKI 2",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-17",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bahasa Melayu",
        "teacher": "- CIKGU MARZUKI 2",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 7 10.30 - 1.00 PTG",
        "type": "Workshop"
      },
      {
        "startTime": "10:30",
        "endTime": "13:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "1",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 7 10.30 - 1.00 PTG",
        "type": "Workshop"
      },
      {
        "startTime": "10:30",
        "endTime": "13:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "1",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Sejarah",
        "teacher": "- CIKGU RAZAK 11.30 - 2.30 TGH",
        "type": "Workshop"
      },
      {
        "startTime": "11:30",
        "endTime": "14:30",
        "subject": "Bahasa Inggeris",
        "teacher": "- CIKGU HAIDA 3",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Sejarah",
        "teacher": "- CIKGU RAZAK 11.30 - 2.30 TGH",
        "type": "Workshop"
      },
      {
        "startTime": "11:30",
        "endTime": "14:30",
        "subject": "Bahasa Inggeris",
        "teacher": "- CIKGU HAIDA 3",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Sejarah",
        "teacher": "- CIKGU RAZAK 11.30 - 2.30 TGH",
        "type": "Workshop"
      },
      {
        "startTime": "11:30",
        "endTime": "14:30",
        "subject": "Bahasa Inggeris",
        "teacher": "- CIKGU HAIDA 3",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "12:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "1",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "12:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "1",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM --- PAGE 2 ---",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 3",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 3",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM --- PAGE 2 ---",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 3",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 3",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH SITI SHAHIDAH BINTI IBRAHIM",
        "type": "Workshop"
      },
      {
        "startTime": "10:30",
        "endTime": "13:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "-",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-18",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH SITI SHAHIDAH BINTI IBRAHIM",
        "type": "Workshop"
      },
      {
        "startTime": "10:30",
        "endTime": "13:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "-",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-19",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Bahasa Melayu",
        "teacher": "PN ROHANI",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-19",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Bahasa Melayu",
        "teacher": "PN ROHANI",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-04-20",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 4",
        "teacher": "HAMIDAH BINTI SHAFEI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-20",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 4",
        "teacher": "HAMIDAH BINTI SHAFEI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-20",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 4",
        "teacher": "HAMIDAH BINTI SHAFEI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-21",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 4",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-21",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 4",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-21",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 4",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-22",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 4",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-22",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 4",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-22",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 4",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-23",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 4",
        "teacher": "● PEPERIKSAAN PERTENGAHAN TAHUN BERMULA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-23",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 4",
        "teacher": "● PEPERIKSAAN PERTENGAHAN TAHUN BERMULA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-23",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 4",
        "teacher": "● PEPERIKSAAN PERTENGAHAN TAHUN BERMULA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-25",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "13:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "-",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-25",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "13:00",
        "subject": "Seminar Pendidikan & Kerjaya",
        "teacher": "-",
        "type": "Seminar"
      }
    ]
  },
  {
    "date": "2026-04-25",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-04-25",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA 10 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL --- PAGE 3 --- (SABTU) 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL --- PAGE 3 --- (SABTU) 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "CIKGU FAIZAL",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 3",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 3",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "CIKGU FAIZAL",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 3",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 3",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH SHAFARINI BINTI SHAARI",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-02",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH SHAFARINI BINTI SHAARI",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-04",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-04",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-05",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-05",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-06",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-06",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-07",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 5",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN AINON BINTI LATIFF 28",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-07",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 5",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN AINON BINTI LATIFF 28",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-07",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-07",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-07",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-08",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-08",
    "dayOfWeek": "friday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-08",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 5",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 29",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 5",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 30",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-08",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 5",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 29",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 5",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 30",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 7 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 7 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 5",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 31",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 5",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN AINON BINTI LATIFF 32",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 5",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 31",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 5",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN AINON BINTI LATIFF 32",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 4",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 4",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 4",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 4",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK AZIZAN BINTI ABDULLAH",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "MARYAUMI BINTI ISHAK LAU SAO LEE",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI --- PAGE 4 --- 1",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD ASPAZILAH BINTI KAMARUDDIN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-09",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK AZIZAN BINTI ABDULLAH",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "MARYAUMI BINTI ISHAK LAU SAO LEE",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI --- PAGE 4 --- 1",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD ASPAZILAH BINTI KAMARUDDIN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-10",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 4",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-10",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 4",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-10",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 4",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-10",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-10",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-11",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 5",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-11",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 5",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-11",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 5",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-11",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Sejarah",
        "teacher": "EN AZLI SULAIMAN",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-11",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Sejarah",
        "teacher": "EN AZLI SULAIMAN",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-12",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 5",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-12",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 5",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-12",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 5",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-13",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 5",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-13",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 5",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-13",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 5",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-14",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 5",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-14",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 5",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-14",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 5",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-14",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-14",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-14",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-16",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "12:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Inggeris",
        "teacher": "TETAMU JEMPUTAN PN WAN HASLINA BINTI WAN HASAN 33",
        "type": "Workshop"
      },
      {
        "startTime": "14:00",
        "endTime": "17:00",
        "subject": "Bengkel Teknik Menjawab Sejarah",
        "teacher": "TETAMU JEMPUTAN PN ROHAYATI BINTI MUHAMAD ZIN JUN 2026 34",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-16",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "12:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Inggeris",
        "teacher": "TETAMU JEMPUTAN PN WAN HASLINA BINTI WAN HASAN 33",
        "type": "Workshop"
      },
      {
        "startTime": "14:00",
        "endTime": "17:00",
        "subject": "Bengkel Teknik Menjawab Sejarah",
        "teacher": "TETAMU JEMPUTAN PN ROHAYATI BINTI MUHAMAD ZIN JUN 2026 34",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-16",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Inggeris",
        "teacher": "-",
        "type": "Workshop"
      },
      {
        "startTime": "11:30",
        "endTime": "14:30",
        "subject": "Bengkel Teknik Menjawab Sej",
        "teacher": "-",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-16",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "11:00",
        "subject": "Bengkel Teknik Menjawab Bahasa Inggeris",
        "teacher": "-",
        "type": "Workshop"
      },
      {
        "startTime": "11:30",
        "endTime": "14:30",
        "subject": "Bengkel Teknik Menjawab Sej",
        "teacher": "-",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-05-17",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 5",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-17",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 5",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-17",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 5",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-05-18",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 6",
        "teacher": "HAMIDAH BINTI SHAFEI 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-18",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 6",
        "teacher": "HAMIDAH BINTI SHAFEI 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-18",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 6",
        "teacher": "HAMIDAH BINTI SHAFEI 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-19",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 6",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI --- PAGE 4 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-19",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 6",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI --- PAGE 4 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-19",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 6",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI --- PAGE 4 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-20",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 6",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-20",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 6",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-20",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 6",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-21",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 6",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-21",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 6",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-21",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 6",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-23",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-05-23",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 6",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 6",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 6",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "sunday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Teknik Menjawab Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-07",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 7",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 7",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 7",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "(KENA GANTI KELAS) CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "(KENA GANTI KELAS) CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-08",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-09",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 7",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-09",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 7",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-09",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 7",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-09",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-09",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-10",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 7",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-10",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 7",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-10",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 7",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-10",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM --- PAGE 3 ---",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-10",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM --- PAGE 3 ---",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 7",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 7",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 7",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 6",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN --- PAGE 5 --- 35",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 6",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN --- PAGE 5 --- 35",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-11",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-12",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 6",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 36",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 6",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 37",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-12",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 6",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 36",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 6",
        "teacher": "PN. NORIZAN BINTI MAMAT PN AINON BINTI LATIFF 37",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 6",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 38",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 6",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN 39",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 6",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN ROHAYATI BINTI MUHAMAD ZIN 38",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 6",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN 39",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH ASHAWANI BINTI CHE AHMAD",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-13",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH ASHAWANI BINTI CHE AHMAD",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-14",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 7",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-14",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 7",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-14",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 7",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-15",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 8",
        "teacher": "HAMIDAH BINTI SHAFEI --- PAGE 5 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-15",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 8",
        "teacher": "HAMIDAH BINTI SHAFEI --- PAGE 5 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-15",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 8",
        "teacher": "HAMIDAH BINTI SHAFEI --- PAGE 5 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-16",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 8",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-16",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 8",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-16",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 8",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-17",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 8",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-17",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 8",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-17",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 8",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-18",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 8",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-18",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 8",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-18",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 8",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-19",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "12:00",
        "subject": "Bengkel Teknik Menjawab Matematik",
        "teacher": "TETAMU JEMPUTAN PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN JULAI 2026 40",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-19",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "12:00",
        "subject": "Bengkel Teknik Menjawab Matematik",
        "teacher": "TETAMU JEMPUTAN PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN JULAI 2026 40",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-20",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-20",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-20",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 4",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 4",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-20",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 4",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 4",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-20",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NAZUMI BINTI NAWAWI",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD NUR HAZFEERA MAZNA BINTI HAZLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-20",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NAZUMI BINTI NAWAWI",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD NUR HAZFEERA MAZNA BINTI HAZLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-21",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 7",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-21",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 7",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-21",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 7",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-22",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 8",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-22",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 8",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-22",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 8",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-23",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 8",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-23",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 8",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-23",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 8",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-24",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 8",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-24",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 8",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-24",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 8",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-25",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 8",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-25",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 8",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-25",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 8",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik 1",
        "teacher": "-",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik 1",
        "teacher": "-",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 5",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 5",
        "teacher": "PN NORASIAH JULAI 2026 --- PAGE 3 ---",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 5",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 5",
        "teacher": "PN NORASIAH JULAI 2026 --- PAGE 3 ---",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA --- PAGE 2 --- JADUAL PROGRAM BEST 2.0 (TERMINAL 1 -",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA --- PAGE 2 --- JADUAL PROGRAM BEST 2.0 (TERMINAL 1 -",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD HALIZA BINTI MUSTAPHA",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-27",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD HALIZA BINTI MUSTAPHA",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-06-28",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 8",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-28",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 8",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-28",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 8",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-06-29",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 9",
        "teacher": "HAMIDAH BINTI SHAFEI --- PAGE 6 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-29",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 9",
        "teacher": "HAMIDAH BINTI SHAFEI --- PAGE 6 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-29",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 9",
        "teacher": "HAMIDAH BINTI SHAFEI --- PAGE 6 --- JADUAL B-TOP TERMINAL 1 (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-30",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 9",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-30",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 9",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-06-30",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 9",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 9",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-01",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 9",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-01",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 9",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-01",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 9",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 10",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 9",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 9",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 9",
        "teacher": "BIL",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 7",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN AINON BINTI LATIFF 41",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 7",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN AINON BINTI LATIFF 41",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-02",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-03",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 7",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 42",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 7",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 43",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-03",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 7",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 42",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 7",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 43",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH --- PAGE 4 --- 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH --- PAGE 4 --- 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 7",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 44",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 7",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN --- PAGE 6 --- OGOS 2026 45",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 7",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 44",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 7",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN --- PAGE 6 --- OGOS 2026 45",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 5",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 5",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 5",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 5",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR --- PAGE 3 --- JADUAL PROGRAM BEST 2.0 (TERMINAL 1 -",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR --- PAGE 3 --- JADUAL PROGRAM BEST 2.0 (TERMINAL 1 -",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH ZULIANA BINTI AB HALIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-04",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH ZULIANA BINTI AB HALIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-05",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 9",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-05",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 9",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-05",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 9",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 2",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-06",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 10",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-06",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 10",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-06",
    "dayOfWeek": "monday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Melayu 10",
        "teacher": "HAMIDAH BINTI SHAFEI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-06",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-06",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-07",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 10",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-07",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 10",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-07",
    "dayOfWeek": "tuesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Bahasa Inggeris 10",
        "teacher": "AMNIE SYAFIQA BINTI MOHD SANUSI 4",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-07",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-07",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-08",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 10",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-08",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 10",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-08",
    "dayOfWeek": "wednesday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Sejarah 10",
        "teacher": "RUBI SURIATI BINTI MOHD RAZALI 5",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-08",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-08",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-09",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 10",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-09",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 10",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-09",
    "dayOfWeek": "thursday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "Matematik 10",
        "teacher": "6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-09",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-09",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-09",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-10",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-10",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 6",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 6",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 6",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 6",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK SITI NUR ADILAH BINTI ABDUL HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD ASPAZILAH BINTI KAMARUDDIN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-11",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK SITI NUR ADILAH BINTI ABDUL HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD ASPAZILAH BINTI KAMARUDDIN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-12",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kandis",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 10",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-12",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kubang Golok",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 10",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-12",
    "dayOfWeek": "sunday",
    "daerah": "Bachok",
    "terminal": "Terminal 2",
    "schoolName": "SMU(A) Darul Iman",
    "sessions": [
      {
        "startTime": "14:40",
        "endTime": "16:40",
        "subject": "PLAY AND TALK 10",
        "teacher": "NOR AUNI YASMIN BINTI RIAZ MUHAMMAD SITI MUNIRAH BINTI ZAKARIA 7",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-07-25",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 6",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 6",
        "teacher": "PN NORHAZALITA OGOS 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-25",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 6",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 6",
        "teacher": "PN NORHAZALITA OGOS 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-25",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "22:30",
        "endTime": "12:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-07-25",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "22:30",
        "endTime": "12:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 7",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 7",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 7",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 7",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 1",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 1",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH MOHD ZAKI BIN HALIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-01",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH MOHD ZAKI BIN HALIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-03",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-03",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-04",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-04",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-05",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-05",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-07",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Kuiz Bahasa Melayu 2",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 46",
        "type": "Quiz"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Kuiz Bahasa Inggeris 2",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 47",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-08-07",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Kuiz Bahasa Melayu 2",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 46",
        "type": "Quiz"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Kuiz Bahasa Inggeris 2",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 47",
        "type": "Quiz"
      }
    ]
  },
  {
    "date": "2026-08-07",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "13:00",
        "endTime": "14:00",
        "subject": "Bahasa Inggeris",
        "teacher": ") -",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-07",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "13:00",
        "endTime": "14:00",
        "subject": "Bahasa Inggeris",
        "teacher": ") -",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-07",
    "dayOfWeek": "friday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "13:00",
        "endTime": "14:00",
        "subject": "Bahasa Inggeris",
        "teacher": ") -",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik 2",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 48",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 2",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN 49",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Matematik 2",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 48",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 2",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN 49",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 7",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 7",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 7",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 7",
        "teacher": "PN NORHAZALITA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NORATIKAH BINTI AMARAN",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD SITI KHAIRIAH BINTI MUA’AINUE-DEEN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-08",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NORATIKAH BINTI AMARAN",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD SITI KHAIRIAH BINTI MUA’AINUE-DEEN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-13",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 8",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN AINON BINTI LATIFF 50",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-13",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 8",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN AINON BINTI LATIFF 50",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-13",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Ayer Lanas",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-13",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Batu Melintang",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-13",
    "dayOfWeek": "thursday",
    "daerah": "Jeli",
    "terminal": "Terminal 2",
    "schoolName": "SMK Kuala Balah",
    "sessions": [
      {
        "startTime": "15:00",
        "endTime": "17:00",
        "subject": "PLAY & TALK",
        "teacher": "-",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-14",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 8",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 51",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 8",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 52",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-14",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 8",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN ROHAYATI BINTI MUHAMAD ZIN 51",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 8",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN 52",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "(kuiz) PUAN SITI SHARIFAH BINTI ISMAIL 7 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "(Kuiz) ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "(kuiz) PUAN SITI SHARIFAH BINTI ISMAIL 7 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "(Kuiz) ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 8",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 53",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 8",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN --- PAGE 7 --- SEPTEMBER 2026 54",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 8",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 53",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 8",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN WAN HASLINA BINTI WAN HASAN --- PAGE 7 --- SEPTEMBER 2026 54",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 8",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 8",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 8",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 8",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "(kuiz) ADIBAH BINTI ABDULLAH SITI SHAHIDAH BINTI IBRAHIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "(Kuiz) YUSUHAIRI BIN REMLI 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-15",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "(kuiz) ADIBAH BINTI ABDULLAH SITI SHAHIDAH BINTI IBRAHIM",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "(Kuiz) YUSUHAIRI BIN REMLI 8",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-17",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-17",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-18",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-18",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-19",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-19",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "(Kuiz) PUAN NUR DIYANA BINTI SUMARDI 10 11.30 - 1.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "(Kuiz) NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "(Kuiz) PUAN NUR DIYANA BINTI SUMARDI 10 11.30 - 1.30 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "(Kuiz) NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 8",
        "teacher": "CIK SUHAIDA --- PAGE 4 ---",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 8",
        "teacher": "PN NORHAZALITA SEPTEMBER 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 8",
        "teacher": "CIK SUHAIDA --- PAGE 4 ---",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 8",
        "teacher": "PN NORHAZALITA SEPTEMBER 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 3",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAACOB",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 3",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK AZIZAN BINTI ABDULLAH --- PAGE 6 --- (Kuiz)",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "(Kuiz) MUHAMAD SUHAIMI BINTI MUHAMMAD NUR HAZFEERA MAZNA BINTI HAZLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-08-22",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK AZIZAN BINTI ABDULLAH --- PAGE 6 --- (Kuiz)",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "(Kuiz) MUHAMAD SUHAIMI BINTI MUHAMMAD NUR HAZFEERA MAZNA BINTI HAZLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-05",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "Workshop"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-05",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "Workshop"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN AZLINAWATI BINTI ARIFIN 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 6",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-07",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-07",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-08",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-08",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-09",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM --- PAGE 4 ---",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-09",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM --- PAGE 4 ---",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-10",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 9",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN ROHAYATI BINTI MUHAMAD ZIN 55",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-09-10",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 9",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN ROHAYATI BINTI MUHAMAD ZIN 55",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-09-11",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 9",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 56",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 9",
        "teacher": "PN. NORIZAN BINTI MAMAT PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 57",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-11",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 9",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN WAN HASLINA BINTI WAN HASAN 56",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 9",
        "teacher": "PN. NORIZAN BINTI MAMAT PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 57",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH --- PAGE 5 --- a 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH --- PAGE 5 --- a 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 9",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN WAN HASLINA BINTI WAN HASAN 58",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 9",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN AINON BINTI LATIFF OKTOBER 2026 59",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 9",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN WAN HASLINA BINTI WAN HASAN 58",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 9",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN AINON BINTI LATIFF OKTOBER 2026 59",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 9",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 9",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 9",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 9",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "EN AZLI SULAIMAN 11.00- 1.00",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "PLAY AND TALK",
        "teacher": "PN ZURRI YATI EN SHAMEER",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH SHAFARINI BINTI SHAARI",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-12",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH SHAFARINI BINTI SHAARI",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-19",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-19",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-19",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN --- PAGE 4 --- JADUAL PROGRAM BEST 2.0 (TERMINAL 1 -",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-19",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN --- PAGE 4 --- JADUAL PROGRAM BEST 2.0 (TERMINAL 1 -",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-19",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NAZUMI BINTI NAWAWI",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD HALIZA BINTI MUSTAPHA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-19",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK NAZUMI BINTI NAWAWI",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD HALIZA BINTI MUSTAPHA",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-26",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 9",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 9",
        "teacher": "PN NORHAZALITA OKTOBER 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-26",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 9",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 9",
        "teacher": "PN NORHAZALITA OKTOBER 2026",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-09-26",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-09-26",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "Workshop"
      }
    ]
  },
  {
    "date": "2026-10-01",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 10",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN WAN HASLINA BINTI WAN HASAN 60",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-10-01",
    "dayOfWeek": "thursday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "PLAY & TALK 10",
        "teacher": "PN. WAN HASLINA BINTI WAN HASAN & EN. MUHAMMAD SYAWAL BIN UJANG PN WAN HASLINA BINTI WAN HASAN 60",
        "type": "PlayAndTalk"
      }
    ]
  },
  {
    "date": "2026-10-02",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 10",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 61",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 10",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN --- PAGE 8 --- 62",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-02",
    "dayOfWeek": "friday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Melayu 10",
        "teacher": "PN. NOORSHMSURIZA BINTI ABDUL RASHID PN NURUL SHAHIDA BINTI MUHAMMAD ZAIN 61",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Sejarah 10",
        "teacher": "PN. NORIZAN BINTI MAMAT PN WAN HASLINA BINTI WAN HASAN --- PAGE 8 --- 62",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "PUAN SITI SHARIFAH BINTI ISMAIL 2 11.00 - 1.00 PTG",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "ENCIK MOHAMAD BUSTAMAN BIN MAT JUSOH 3",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 10",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN AINON BINTI LATIFF 63",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 10",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN ROHAYATI BINTI MUHAMAD ZIN NOVEMBER 2026 - JANUARI 2027 PEPERIKSAAN SPM FEBRUARI - MAC 2027 Sabtu (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Gua Musang",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tengku Indra Petra 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:00",
        "subject": "Bahasa Inggeris 10",
        "teacher": "PN. SURYATI BINTI MOHD SALLEH PN AINON BINTI LATIFF 63",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "12:30",
        "subject": "Matematik 10",
        "teacher": "PN. WARDAH NABILAH BINTI MOHD NASIR PN ROHAYATI BINTI MUHAMAD ZIN NOVEMBER 2026 - JANUARI 2027 PEPERIKSAAN SPM FEBRUARI - MAC 2027 Sabtu (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Sejarah",
        "teacher": "-",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR 3",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Bahasa Melayu",
        "teacher": "PN. ZAWIAH BINTI JAAFAR",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH LAU SAO LEE",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-03",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Melayu",
        "teacher": "ADIBAH BINTI ABDULLAH LAU SAO LEE",
        "type": "IVC"
      },
      {
        "startTime": "11:00",
        "endTime": "13:00",
        "subject": "Sejarah",
        "teacher": "YUSUHAIRI BIN REMLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-05",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-05",
    "dayOfWeek": "monday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Inggeris",
        "teacher": "EN AFNAN",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-06",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-06",
    "dayOfWeek": "tuesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Bahasa Melayu",
        "teacher": "PN ROHANI ABDULLAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-07",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Bandar Kuala Krai",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-07",
    "dayOfWeek": "wednesday",
    "daerah": "Kuala Krai",
    "terminal": "Terminal 2",
    "schoolName": "SMK Sultan Yahya Petra 1",
    "sessions": [
      {
        "startTime": "14:30",
        "endTime": "16:30",
        "subject": "Matematik",
        "teacher": "CIK AZIANI IBRAHIM",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMK Sri Gunung",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Bachok",
    "terminal": "Terminal 1",
    "schoolName": "SMU(A) Darul Ulum Al-Muhammadiah",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PUAN NUR DIYANA BINTI SUMARDI 4 10.30 - 11.30 PG",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "MUHAMMAD AZAM BIN ISMAIL NURUL ANIS ZURAINI BINTI YUSOF SOBRI 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "NORMASUHANA BINTI MAT ALI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 10",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 10",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "MOHD MUSTAQIM",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Sejarah 10",
        "teacher": "CIK NORAINI",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik 10",
        "teacher": "PN NORASIAH",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. AZLINAWATI BINTI ARIFIN 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 1",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK SITI NUR ADILAH BINTI ABDUL HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD SITI NUR HAZFEERA BINTI HAZLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-10",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 2",
    "schoolName": "SMK Tanah Merah 2",
    "sessions": [
      {
        "startTime": "08:30",
        "endTime": "10:30",
        "subject": "Bahasa Inggeris",
        "teacher": "MARYAUMI BINTI ISHAK SITI NUR ADILAH BINTI ABDUL HALIM",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "NAZIR BIN AZMI/ MUHAMMAD HANIF FITRI BIN MUHD SAWADI 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Matematik",
        "teacher": "MUHAMAD SUHAIMI BINTI MUHAMMAD SITI NUR HAZFEERA BINTI HAZLI",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-24",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 10",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 9",
        "teacher": "PN NORHAZALITA NOVEMBER 2026 - JANUARI 2027 PEPERIKSAAN SPM FEBRUARI - MAC 2027 Sabtu (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-24",
    "dayOfWeek": "saturday",
    "daerah": "Jeli",
    "terminal": "Terminal 1",
    "schoolName": "SMK Jeli 2",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "09:00",
        "subject": "PLAY & TALK",
        "teacher": "AHAMAD SAYUTI",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "09:00",
        "endTime": "11:00",
        "subject": "Bahasa Inggeris 10",
        "teacher": "CIK SUHAIDA",
        "type": "IVC"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Melayu 9",
        "teacher": "PN NORHAZALITA NOVEMBER 2026 - JANUARI 2027 PEPERIKSAAN SPM FEBRUARI - MAC 2027 Sabtu (",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-24",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Ipoh",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  },
  {
    "date": "2026-10-24",
    "dayOfWeek": "saturday",
    "daerah": "Tanah Merah",
    "terminal": "Terminal 1",
    "schoolName": "SMK Tan Sri Mohamed Yaacob",
    "sessions": [
      {
        "startTime": "08:00",
        "endTime": "10:30",
        "subject": "Matematik",
        "teacher": "PN. NORITA BINTI YAAKOB",
        "type": "IVC"
      },
      {
        "startTime": "10:30",
        "endTime": "11:30",
        "subject": "PLAY & TALK",
        "teacher": "PN. SURAYA BINTI ZAKARIA 5 11.30 - 1.30 PTG",
        "type": "PlayAndTalk"
      },
      {
        "startTime": "11:30",
        "endTime": "13:30",
        "subject": "Bahasa Inggeris",
        "teacher": "PN. NORA HASLINA BINTI ILIAS 1",
        "type": "IVC"
      }
    ]
  }
];

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { schedules };
}

if (typeof window !== 'undefined') {
  window.BTOP_COMPLETE_SCHEDULES = schedules;
}

export { schedules };
export default schedules;
